// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/lineup-position.json
// "P", "C", "1B", "2B", "3B", "SS", "LF", "CF", "RF", "EF", "EH", "DH"

const LineupPosition = {
    Pitcher: { key: 'P', name: 'Pitcher' },
    Catcher: { key: 'C', name: 'Catcher' },
    FirstBaseman: { key: '1B', name: 'First Baseman' },
    SecondBaseman: { key: '2B', name: 'Second Baseman' },
    ThirdBaseman: { key: '3B', name: 'Third Baseman' },
    ShortStop: { key: 'SS', name: 'Short Stop' },
    LeftFielder: { key: 'LF', name: 'Left Fielder' },
    CenterFielder: { key: 'CF', name: 'Center Fielder' },
    RightFielder: { key: 'RF', name: 'Right Fielder' },
    ExtraFielder: { key: 'EF', name: 'Extra Fielder' },
    ExtraHitter: { key: 'EH', name: 'Extra Hitter' },
    DesignatedHitter: { key: 'DH', name: 'Designated Hitter' },
};

export default LineupPosition;